
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/[url_slug]",
      function () {
        return require("private-next-pages/expertise/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/[url_slug]"])
      });
    }
  